import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "../contexts/AuthContext";
import { useLanguage } from "../contexts/LanguageContext";
import { flushTikTok, handleTikTokStorageChange, initializeTikTok, marketingPage, privacySignal, retryTikTokRevocations, setTikTokAuth, setTikTokConsent, tiktokConsent, trackTikTokRoute } from "../utils/tiktok";
import styles from "./TikTokMeasurement.module.css";

export default function TikTokMeasurement() {
  const location = useLocation();
  const { session, loading: authLoading } = useAuthContext();
  const { language } = useLanguage();
  const [enabled, setEnabled] = useState(false);
  const [open, setOpen] = useState(false);
  const [revision, setRevision] = useState(0);
  const [explicit, setExplicit] = useState(false);
  const ar = location.pathname.startsWith("/ar/") || new URLSearchParams(location.search).get("lang") === "ar" || language === "ar";

  useEffect(() => {
    void initializeTikTok().then(config => {
      setEnabled(config.enabled);
      if (config.enabled && privacySignal()) void setTikTokConsent(false);
      else if (config.enabled && !tiktokConsent()) setOpen(true);
    });
    const changed = () => { setOpen(false); setRevision(value => value + 1); };
    const preferences = () => { setExplicit(true); setOpen(true); };
    const retry = () => {
      void retryTikTokRevocations();
      if (tiktokConsent()?.granted) void flushTikTok();
    };
    const storage = (event: StorageEvent) => {
      if (handleTikTokStorageChange(event)) changed();
    };
    window.addEventListener("cshaped-tiktok-consent", changed);
    window.addEventListener("cshaped-tiktok-preferences", preferences);
    window.addEventListener("online", retry);
    window.addEventListener("storage", storage);
    const timer = window.setInterval(() => { void flushTikTok(); }, 30000);
    return () => {
      window.removeEventListener("cshaped-tiktok-consent", changed);
      window.removeEventListener("cshaped-tiktok-preferences", preferences);
      window.removeEventListener("online", retry);
      window.removeEventListener("storage", storage);
      window.clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    if (!authLoading) setTikTokAuth(session?.access_token, session?.user?.id);
  }, [authLoading, session?.access_token, session?.user?.id]);
  useEffect(() => {
    if (!authLoading) void trackTikTokRoute(`${location.key}:${revision}`);
  }, [authLoading, location.key, revision]);

  if (!enabled || !open || (!explicit && !marketingPage() && !["/privacy-policy", "/signup", "/login", "/mock-exams/demo", "/payment-confirmation", "/payment-callback"].includes(location.pathname))) return null;
  // Short, conventional cookie notice; the privacy policy carries the detail.
  return <aside className={styles.banner} role="region" aria-label={ar ? "ملفات تعريف الارتباط" : "Cookies"} dir={ar ? "rtl" : "ltr"}>
    <p className={styles.text}>
      {ar
        ? "نستخدم ملفات تعريف الارتباط، ومنها ملفات شركائنا الإعلانيين، لقياس إعلاناتنا وتحسينها. "
        : "We use cookies, including from our advertising partners, to measure and improve our ads. "}
      <a href="/privacy-policy">{ar ? "اعرف المزيد" : "Learn more"}</a>
    </p>
    <div className={styles.actions}>
      <button type="button" className={styles.secondary} onClick={() => { void setTikTokConsent(false); }}>{ar ? "رفض" : "Decline"}</button>
      <button type="button" className={styles.primary} disabled={privacySignal()} onClick={() => { void setTikTokConsent(true); }}>{ar ? "قبول" : "Accept"}</button>
    </div>
  </aside>;
}
